var map = {
	"./Admin.vue": [
		"f529",
		"chunk-e5267ff6",
		"chunk-cc54c8a8"
	],
	"./BodyContent.vue": [
		"19a8",
		"chunk-e5267ff6",
		"chunk-c3b6a6f8"
	],
	"./CardSets.vue": [
		"aa09",
		"chunk-3c819c08",
		"chunk-3063d78a"
	],
	"./CardsContainer.vue": [
		"6136",
		"chunk-18c81973",
		"chunk-6740edda",
		"chunk-033bfd47"
	],
	"./CryptContent.vue": [
		"28fe",
		"chunk-18c81973",
		"chunk-6740edda",
		"chunk-033bfd47",
		"chunk-b4928050"
	],
	"./CryptTable.vue": [
		"c618",
		"chunk-18c81973",
		"chunk-95263ade"
	],
	"./DataIndicators.vue": [
		"daf8",
		"chunk-34294a1e",
		"chunk-3c819c08",
		"chunk-03021e0f"
	],
	"./EventNotification.vue": [
		"cdb9"
	],
	"./Feedback.vue": [
		"a6be",
		"chunk-64a89dc7"
	],
	"./HelpContent.vue": [
		"772c",
		"chunk-13901d54"
	],
	"./MarketContent.vue": [
		"e7db",
		"chunk-3c819c08",
		"chunk-f7986b6e"
	],
	"./OthersCryptContent.vue": [
		"1d45",
		"chunk-18c81973",
		"chunk-6740edda",
		"chunk-033bfd47",
		"chunk-047813d1"
	],
	"./OwnedCardContent.vue": [
		"26be",
		"chunk-c904431c"
	],
	"./OwnerBalances.vue": [
		"ebbc",
		"chunk-59a48d01"
	],
	"./RealtimeEvents.vue": [
		"a25f"
	],
	"./ShopContent.vue": [
		"161d",
		"chunk-6740edda",
		"chunk-3155e723"
	],
	"./SortDropdown.vue": [
		"17f5",
		"chunk-6740edda"
	],
	"./TokenContent.vue": [
		"929b",
		"chunk-18c81973",
		"chunk-e5267ff6",
		"chunk-3ef87902"
	],
	"./TransactionModal.vue": [
		"203d"
	],
	"./UniverseBalances.vue": [
		"846b",
		"chunk-719f79c8"
	],
	"./charts/DoughnutChart.vue": [
		"ac27",
		"chunk-34294a1e",
		"chunk-2d2132dd"
	],
	"./charts/LineChart.vue": [
		"33e7",
		"chunk-34294a1e",
		"chunk-2d0b9bc8"
	],
	"./layout/AppFooter.vue": [
		"ec0b"
	],
	"./layout/CzxpRewardEffect.vue": [
		"36a5"
	],
	"./layout/Header.vue": [
		"96c7"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "0f13";
module.exports = webpackAsyncContext;